import { formatDateToString, formatTimeToString, getIdFromUrl } from '@/helpers'
import { runtime } from '~/app/environment'
import { PATH } from '~/shared/constants/path'

/**
 * Converts a JavaScript object to a Base64-encoded string.
 *
 * Serializes the object to JSON, then encodes it in Base64 format.
 * Used for macros/ad request headers.
 *
 * @param obj - The object to be converted to a Base64 string.
 * @returns The Base64-encoded string representation of the object.
 *
 * @example
 * const data = { userId: 123, session: "abc" }
 * const encoded = objToStringBase64(data)
 */
const objToStringBase64 = (obj: Record<string, unknown>): string => {
  const objJsonStr = JSON.stringify(obj)
  const b64Str = btoa(objJsonStr)

  return b64Str
}

/**
 * Function adds '/play', removes entity title.
 * For example, function will return url 'https://any.com/movie/486/play' if window.location.href was https://any.com/movie/power-saw-486
 */
export const getPageUrl = (): string => {
  const { pathname = '', search = '' } = new URL(window.location.href)
  let pageUrl = ''
  const h = pathname.replace(/\/play$/, '')
  const id = getIdFromUrl(h) || Number(h.split('/').pop()) || null
  /* Handle urls like /movie/movie-title-1796/play?{search}, /movie/1796/play, /movie/movie-title-1796, /movie/1796 */
  if (pathname.includes(PATH.MOVIE)) {
    pageUrl = id
      ? `${window.location.origin}${PATH.MOVIE}/${id}${PATH.PLAY}${search}`
      : ''
  }

  if (pathname.includes(PATH.LIVE)) {
    pageUrl = id
      ? `${window.location.origin}${PATH.LIVE}/${id}${PATH.PLAY}${search}`
      : ''
  }

  if (pathname.includes(PATH.TVSHOW)) {
    pageUrl = id
      ? `${window.location.origin}${PATH.TVSHOW}/${id}${PATH.PLAY}${search}`
      : ''
  }

  return pageUrl
}

const getPlayerDimensions = () => {
  const el = document.querySelector('.player-container')
  const rect = el?.getBoundingClientRect()

  const width = Math.round(rect?.width ?? window.innerWidth)
  const height = Math.round(rect?.height ?? window.innerHeight)

  return { width, height }
}

export const getMacrosHeader = (
  requestRandom: number,
  userGuid: string,
  nonce?: string
): string => {
  const now = new Date()

  const date = formatDateToString(now)
  const time = formatTimeToString(now)
  const { width, height } = getPlayerDimensions()

  const header = {
    requestRandom,
    app: {
      name: runtime.app.name,
      adv: {
        id: userGuid,
        doTrack: 1,
        doNotTrack: 0,
      },
    },
    platform: 'web',
    player: {
      inview: '1', // always 1
      inviewPerc: '100', // always 100
      width: String(width),
      height: String(height),
    },
    system: {
      date, //  Current date in the format yyyy-mm-dd
      time, //  Current time in the format hh-mm-ss
    },
    gPalKey: nonce || '',
    pageUrl: getPageUrl(),
  }

  return objToStringBase64(header)
}
